import { render, staticRenderFns } from "./personalityTest.vue?vue&type=template&id=f8442b5e&scoped=true&"
import script from "./personalityTest.vue?vue&type=script&lang=js&"
export * from "./personalityTest.vue?vue&type=script&lang=js&"
import style0 from "./personalityTest.vue?vue&type=style&index=0&id=f8442b5e&scoped=true&lang=less&"
import style1 from "./personalityTest.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8442b5e",
  null
  
)

export default component.exports